import { baseService } from 'modules/baseService';
import HttpClient from 'services/HttpClient';
import { HelpQuestion } from 'models/HelpQuestion';

const baseUrl = '/help';

export const getHelp = baseService<void, HelpQuestion[]>(() =>
  HttpClient.get(baseUrl),
);
